import PhotoUpload from '@/components/upload-image'
import Status from '@/status'
export default {
  name: 'create',
  components: {PhotoUpload},
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      user: {
        grp_id: '',
        email: '',
        // org_id: '',
        gender: '',
        post_code: '',
        avatar: '',
        name: '',
        status: '',
        password: '',
        repass: ''
      },
      errors: {},
      btn_reset: false,
      btn_create: false,
      accept: 'image/*',
      loading: true
    }
  },
  computed: {
    groups () {
      return this.$store.getters['Group/getListGroup']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    positions () {
      return this.$store.getters['Position/getListPosition']
    },
    status () {
      return this.$store.getters['Status/getStatusUserCode']
    }
  },
  mounted () {
  
    this.btn_reset = true
    this.btn_create = true
    Promise.all([
      this.$store.dispatch('Status/getListStatus'),
      this.$store.dispatch('Group/getListGroup', {page: 1, per_page: 'all', status: Status.APPROVAL}),
      this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all', status: Status.APPROVAL}),
      this.$store.dispatch('Position/getListPosition', {page: 1, per_page: '', status: Status.APPROVAL})
    ]).then(res => {
      
      this.btn_reset = false
      this.btn_create = false
      this.loading = false
    }).catch(errors => {
      console.log(errors)
      
      this.btn_reset = false
      this.btn_create = false
      this.loading = false
    })
  },
  methods: {
    reset () {
      this.errors = {}
      this.user = {
        grp_id: '',
        email: '',
        // org_id: '',
        gender: '',
        post_code: '',
        avatar: '',
        name: '',
        status: '',
        password: '',
        repass: '',
        info: ''
      }
    },

    fileChange (file) {
      this.user.avatar = file
    },

    create () {
      const fd = new FormData()
      fd.append('avatar', this.user.avatar)
      fd.append('name', this.user.name)
      fd.append('email', this.user.email)
      fd.append('gender', this.user.gender)
      fd.append('post_code', this.user.post_code)
      fd.append('org_id', this.user.org_id)
      fd.append('grp_id', this.user.grp_id)
      fd.append('password', this.user.password)
      fd.append('repass', this.user.repass)
      fd.append('status', this.user.status)
      fd.append('info', this.user.info)

    
      this.btn_reset = true
      this.btn_create = true
      this.$store.dispatch('User/createUser', {user: fd}).then(res => {
        
        this.btn_reset = false
        this.btn_create = false
        this.$router.push('list')
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
          this.btn_reset = false
          this.btn_create = false
        }
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/user/create/create.js